import { render, staticRenderFns } from "./ManagementPatient.vue?vue&type=template&id=c355f60e&scoped=true&"
import script from "./ManagementPatient.vue?vue&type=script&lang=js&"
export * from "./ManagementPatient.vue?vue&type=script&lang=js&"
import style0 from "./ManagementPatient.vue?vue&type=style&index=0&id=c355f60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355f60e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c355f60e')) {
      api.createRecord('c355f60e', component.options)
    } else {
      api.reload('c355f60e', component.options)
    }
    module.hot.accept("./ManagementPatient.vue?vue&type=template&id=c355f60e&scoped=true&", function () {
      api.rerender('c355f60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clinic/components/Management/components/ManagementPatient.vue"
export default component.exports